export default "/fonts/vendor/@mdi/materialdesignicons-webfont.ttf?89ae221302c6617c0a87cc0442d11667";